import * as $ from 'jquery';

export default (function () {
  $('.search-toggle').on('click', e => {
    $('.search-box, .search-input').toggleClass('active');
    $('.search-input input').focus();
    e.preventDefault();
  });
}());



// WEBPACK FOOTER //
// ./resources/assets/js/search/index.js